<template>
    <div class="container">
        <b-table md-card md-fixed-header v-model="detalleEcp">
            <b-table-toolbar>
                <h1 class="md-title">{{ labels.detail }}</h1>
                <b-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary" @click="deleteAllEcp" :disabled="readOnly">
                    <i>delete</i>
                </b-button>
                <b-button style="background-color: #e5ac00; width: 35px; height: 35px;" class="md-fab md-primary" @click="editAllEcp" :disabled="readOnly">
                    <i>edit</i>
                </b-button>
                <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="newEcp" :disabled="readOnly">
                    <i class="fa-solid fa-plus"></i>
                </b-button>
            </b-table-toolbar>
            <b-table-row slot="b-table-row" slot-scope="{ item }">
                <b-table-cell :md-label="labels.contable">{{ getContable(item?.contable) }}</b-table-cell>
                <b-table-cell :md-label="labels.cuenta">{{ item?.cuenta || '-' }}</b-table-cell>
                <b-table-cell :md-label="labels.actual">{{ getActual(item?.actual) }}</b-table-cell>
                <b-table-cell :md-label="labels.operacion">{{ item?.operacion || '-' }}</b-table-cell>
                <b-table-cell :md-label="labels.formulacion">{{ getFormulacion(item?.formulacion, item?.contable) }}</b-table-cell>
                <b-table-cell :md-label="labels.editar">
                    <b-button style="background-color: #e5ac00; width: 35px; height: 35px;" class="md-fab md-primary" @click="editCuenta(item.id)" :disabled="readOnly">
                        <i>edit</i>
                    </b-button>
                </b-table-cell>
                <b-table-cell :md-label="labels.eliminar">
                    <b-button style="background-color: #cd2838; width: 35px; height: 35px;" class="md-fab md-primary" @click="deleteDetaEcp(item.id)" :disabled="readOnly">
                        <i>delete</i>
                    </b-button>
                </b-table-cell>
            </b-table-row>
        </b-table>

        <NewCuentaEcp 
            :modalCreaEcp="modalCreaEcp" 
            @cierraMod="closeMod" 
            :vigComSelect="ItemVigCom" 
            :cuentasCreadas="listCuentExist" 
            :readOnly="readOnly" 
            @reloadTable="recargaTbl"
        />
        
        <EditaCuentaEcp 
            :modalEditaEcp="modalEditaEcp" 
            :dataDetallEcp="infoDetEcp" 
            :readOnly="readOnly" 
            @cierraMod="closeMod" 
            @reloadTable="recargaTbl" 
        />
        
        <EditMasivoEcp 
            :modalEditAllEcp="modalEditAllEcp" 
            :dataVigComFilCol="consulDetallEcp" 
            :readOnly="readOnly" 
            @closeModal="closeMod" 
            @reloadTable="recargaTbl"
        />
        
        <ConfirmDialog 
            :showConfirmDialog="showConfirmDialog" 
            @cancelDel="closeMod" 
            @confirmDelete="confirmDelete" 
        />
    </div>
</template>

<script>
import NewCuentaEcp from './NewCuentaEcp.vue'
import EditaCuentaEcp from './EditaCuentaEcp.vue'
import EditMasivoEcp from './EditMasivoEcp.vue'
import EcpReporte from '../../services/EcpReporte'
import ConfirmDialog from '../niveles/ConfirmDialog.vue'

export default {
    name: "EcpDetalle",
    props: {
        consulDetallEcp: {
            type: Array,
            default: () => []
        },
        ItemVigCom: {
            type: Object,
            default: () => ({})
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    components: {
        NewCuentaEcp,
        EditaCuentaEcp,
        EditMasivoEcp,
        ConfirmDialog
    },
    data: () => ({
        detalleEcp: [],
        modalCreaEcp: false,
        modalEditaEcp: false,
        modalEditAllEcp: false,
        listCuentExist: [],
        showConfirmDialog: false,
        infoDetEcp: {},
        deleteAllReg: false,
        regDel: null
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    detail: "Detalle",
                    contable: "Contable",
                    cuenta: "Cuenta",
                    actual: "Actual",
                    operacion: "Operación",
                    formulacion: "Formulación",
                    editar: "Editar",
                    eliminar: "Eliminar",
                }
            } else {
                return {
                    detail: "Detail",
                    contable: "Accountant",
                    cuenta: "Account",
                    actual: "Actual",
                    operacion: "Operation",
                    formulacion: "Formulation",
                    editar: "Edit",
                    eliminar: "Delete",
                }
            }
        }
    },
    methods: {
        showReadOnlyToast() {
            this.$toast.error('La vigencia seleccionada está deshabilitada para crear o editar.')
        },

        getContable(valContable) {
            return valContable == 1 ? 'SI' : 'NO'
        },

        getActual(valActual) {
            return valActual == 1 ? 'SI' : 'NO'
        },

        getFormulacion(valFormulacion, valContable) {
            if (valContable == 1) {
                return ""
            } else {
                return valFormulacion || '-'
            }
        },

        newEcp() {
            if (this.readOnly) {
                this.showReadOnlyToast()
                return
            }
            this.modalCreaEcp = true
        },

        async editCuenta(item) {
            if (this.readOnly) {
                this.showReadOnlyToast()
                return
            }
            try {
                let info = await EcpReporte.getDetCuentaEcpById(item)
                this.infoDetEcp = info.data.detCuentEcp
                this.modalEditaEcp = true
            } catch (err) {
                console.error(err)
                this.$toast.error('Error al cargar los datos de la cuenta')
            }
        },

        editAllEcp() {
            if (this.readOnly) {
                this.showReadOnlyToast()
                return
            }
            this.modalEditAllEcp = true
        },

        deleteDetaEcp(item) {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para eliminar.')
                return
            }
            this.regDel = item
            this.deleteAllReg = false
            this.showConfirmDialog = true
        },

        deleteAllEcp() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para eliminar.')
                return
            }
            this.deleteAllReg = true
            this.showConfirmDialog = true
        },

        confirmDelete() {
            if (this.readOnly) {
                this.$toast.error('La vigencia seleccionada está deshabilitada para eliminar.')
                this.showConfirmDialog = false
                return
            }
            
            if (this.deleteAllReg) {
                EcpReporte.deleteAllDetEcp(this.ItemVigCom)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$toast.success(res.data.message || 'Registros eliminados correctamente')
                            this.showConfirmDialog = false
                            this.recargaTbl(this.ItemVigCom)
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                        this.$toast.error('Error al eliminar los registros')
                    })
            } else {
                EcpReporte.deleteDetCuentaEcp(this.regDel)
                    .then((res) => {
                        if (res.status == 200) {
                            this.$toast.success("Se ha eliminado el registro.")
                            this.showConfirmDialog = false
                            this.recargaTbl(this.ItemVigCom)
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                        this.$toast.error('Error al eliminar el registro')
                    })
            }
        },

        closeMod() {
            this.modalCreaEcp = false
            this.modalEditaEcp = false
            this.modalEditAllEcp = false
            this.showConfirmDialog = false
        },

        recargaTbl(itemRef) {
            // Emitir evento para recargar desde el padre
            this.$emit('refresh')
            
            // También recargar localmente
            if (itemRef) {
                EcpReporte.consDetalleEcp(itemRef)
                    .then((res) => {
                        if (res.status == 200) {
                            this.detalleEcp = res.data.detEcp || []
                        }
                    })
                    .catch((err) => {
                        console.error(err)
                        if (err.response?.status == 404) {
                            this.detalleEcp = []
                        }
                    })
            }
            
            // Cerrar modales
            this.modalCreaEcp = false
            this.modalEditaEcp = false
            this.modalEditAllEcp = false
            this.showConfirmDialog = false
        }
    },
    watch: {
        consulDetallEcp: {
            immediate: true,
            handler(newVal) {
                if (newVal && Array.isArray(newVal)) {
                    this.detalleEcp = newVal
                    
                    this.listCuentExist = []
                    newVal.forEach((elem) => {
                        if (elem.cuenta != null) {
                            this.listCuentExist.push({
                                id_compania: elem.id_compania,
                                vigencia: elem.vigencia,
                                fila: elem.fila,
                                columna: elem.columna,
                                cuenta: elem.cuenta,
                            })
                        }
                    })
                } else {
                    this.detalleEcp = []
                    this.listCuentExist = []
                }
            }
        }
    }
}
</script>

<style src="../main.css"></style>